<script>
	import Button from './Button.svelte';
	let className = '';
	export { className as class };
	export let width;
	export let height;
	export let fontSize;
	export let text;
	export let emoji;
	export let disabled = true;
	export let onClick = () => {};
	export let onMouseDown = () => {};
</script>

<div class="wrappertransparent">
	<Button
		class="transparent-btn {className}"
		{width}
		{height}
		{fontSize}
		{disabled}
		{onClick}
		{onMouseDown}
	>
		<span class="transparent-btnText">
			{text}
		</span>
		{#if emoji}
			<span class="transparent-btnEmoji">
				{emoji}
			</span>
		{/if}
	</Button>
</div>

<style>
	.wrappertransparent {
		width: fit-content;
		height: fit-content;
	}
	.wrappertransparent :global(.transparent-btn) {
		width: var(--width);
		height: var(--height);
		cursor: pointer;
		background-color: transparent;
		border: 2px solid #ffffff;
		border-radius: 18px;
		margin: 0;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 4px;
		box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.15);
	}
	.transparent-btnText,
	.transparent-btnEmoji {
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		font-size: var(--fontSize);
		line-height: var(--lineHeight);
		text-align: center;
		letter-spacing: -0.025em;
		color: #ffffff;
		margin: 0px 1px;
	}
	.transparent-btnText {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	@media only screen and (max-width: 550px) {
		.wrappertransparent :global(.transparent-btn) {
			width: var(--height);
			height: var(--height);
			border-radius: 50%;
		}
		.transparent-btnText {
			display: none;
		}
	}
</style>
